module.exports = new __parcel__URL__("on-call-panel-skeleton.tpl.d7139b03.svg").toString();